module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.busy) ? _c('h2', [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), _c('UserCreator', {
    attrs: {
      "step": "1",
      "active": _vm.activeStep === 'UserCreator'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone
    }
  }), _vm._v(" "), _c('AddressCreator', {
    attrs: {
      "step": "2",
      "active": _vm.activeStep === 'AddressCreator'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone
    }
  }), _vm._v(" "), _c('PaymentMethodCreator', {
    attrs: {
      "step": "3",
      "active": _vm.activeStep === 'PaymentMethodCreator'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone
    }
  }), _vm._v(" "), _c('ReviewDirect', {
    attrs: {
      "step": "4",
      "active": _vm.activeStep === 'ReviewDirect'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45382956!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepsDirect.vue
// module id = 376
// module chunks = 1